import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Passwords do not match");
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="light-scope flex items-center justify-center px-5 py-16 min-h-screen">
      <div className="w-full max-w-md">
        <div className="font-display text-4xl tracking-tight text-[#0A0D0B]">Grafton<span className="text-[#B89874]">.</span></div>
        <p className="mt-2 text-[11px] uppercase tracking-[0.28em] text-[#B89874]">Reset Password</p>
        {!token ? (
          <p className="mt-8 text-[#58635C]">
            Invalid reset link. <Link to="/admin/login" className="underline">Return to sign in</Link>.
          </p>
        ) : (
          <form onSubmit={submit} data-testid="reset-form" className="mt-10 space-y-5">
            <div className="flex flex-col gap-2">
              <label className="text-[11px] uppercase tracking-[0.16em] text-[#58635C]">New password</label>
              <input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required
                className="border border-[#E5E1D8] px-4 py-3 text-[#0A0D0B] focus:border-[#B89874] outline-none transition-colors" />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-[11px] uppercase tracking-[0.16em] text-[#58635C]">Confirm password</label>
              <input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required
                className="border border-[#E5E1D8] px-4 py-3 text-[#0A0D0B] focus:border-[#B89874] outline-none transition-colors" />
            </div>
            <button type="submit" disabled={busy} data-testid="reset-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#0A0D0B] text-white px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] hover:bg-[#233027] transition-colors disabled:opacity-60">
              {busy && <Loader2 size={15} className="animate-spin" />} Update Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
